import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { UserEntity } from '@data';
import Member from './member';
import MembersContainer from './membersList';

export interface MembersProps {
  user: UserEntity;
}

const MembersRouter = ({ user }: MembersProps): ReactElement => (
  <Routes>
    <Route path=":membershipId" element={<Member user={user} />} />
    <Route path="*" element={<MembersContainer user={user} />} />
  </Routes>
);

export default MembersRouter;
